<template>
  <nuxt-link
    :to="to"
    :class="{
      'btn-tag-fill': !secondary,
      'btn-tag-outline': secondary,
    }"
    class="btn-tag whitespace-nowrap"
  >
    <slot />
  </nuxt-link>
</template>

<script>
export default defineNuxtComponent({
  props: {
    to: {
      type: [Object, String],
      required: true,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
